<template>
  <div class="reapal-apply">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入关键词查找..."></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.audit_state"
                  clearable
                  style="width:80px"
                  placeholder="请选择状态...">
            <Option v-for="item in audit_state"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加 start -->
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Form :model="dataInfo"
            :label-width="50"
            ref="dataInfoValidate"
            :rules="dataInfoValidate">
        <Row>
          <Col span="8">
          <FormItem label="园区"
                    label-position="top">
            <Select v-model="dataInfo.park_uuid"
                    clearable
                    placeholder="选择园区">
              <Option v-for="item in parkList"
                      :value="item.park_uuid"
                      :key="item.park_uuid">{{item.name}}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="注册类型"
                    label-position="top">
            <RadioGroup v-model="dataInfo.registration_type">
              <Radio label="01">企业</Radio>
              <!-- <Radio label="02">个体工商户</Radio> -->
            </RadioGroup>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="企业全称"
                    label-position="top"
                    prop="enterprise_name">
            <Input v-model="dataInfo.enterprise_name"></Input>
          </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="8">
          <FormItem label="营业执照编号"
                    label-position="top">
            <Input v-model="dataInfo.business_code"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="营业执照有效期"
                    label-position="top">
            <!-- <DatePicker
                v-model="dataInfo.business_valid_date"
                format="yyyy-MM-dd"
                placeholder="营业执照有效期"
                style="width: 200px"
                @on-change="changeBvd"
              ></DatePicker>-->
            <Input v-model="dataInfo.business_valid_date"
                   placeholder="例：2099-12-31"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="注册资本"
                    label-position="top">
            <Input v-model="dataInfo.registered_capital"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
          <FormItem label="开户名"
                    label-position="top"
                    prop="open_account_name">
            <Input v-model="dataInfo.open_account_name"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="开户银行"
                    label-position="top"
                    prop="open_account_bank">
            <Input v-model="dataInfo.open_account_bank"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="结算账户号"
                    label-position="top"
                    prop="settle_account_no">
            <Input v-model="dataInfo.settle_account_no"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
          <FormItem label="法人身份证号"
                    label-position="top"
                    prop="cert_no">
            <Input v-model="dataInfo.cert_no"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="法人证件有效期"
                    label-position="top"
                    prop="legal_person_cert_date">
            <!-- <DatePicker
                v-model="dataInfo.legal_person_cert_date"
                format="yyyy-MM-dd"
                placeholder="法人证件有效期"
                style="width: 200px"
                @on-change="changeLpcd"
              ></DatePicker>-->
            <Input v-model="dataInfo.legal_person_cert_date"
                   placeholder="例：2099-12-31"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="法人姓名"
                    label-position="top"
                    prop="legal_person_name">
            <Input v-model="dataInfo.legal_person_name"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
          <FormItem label="法人常用邮箱"
                    label-position="top">
            <Input v-model="dataInfo.legal_person_email"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="法人手机号"
                    label-position="top">
            <Input v-model="dataInfo.legal_person_mobile"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="股东名"
                    label-position="top">
            <Input v-model="dataInfo.shareholder"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
          <FormItem label="法人银行卡"
                    label-position="top">
            <Input v-model="dataInfo.legal_person_card_no"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
          <FormItem label="所属省"
                    label-position="top"
                    prop="province_name">
            <Input v-model="dataInfo.province_name"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="所属市"
                    label-position="top"
                    prop="city_name">
            <Input v-model="dataInfo.city_name"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="设备通道"
                    label-position="top">
            <RadioGroup v-model="dataInfo.channel">
              <Radio label="0">PC</Radio>
              <Radio label="1">手机</Radio>
              <Radio label="2">pad</Radio>
              <Radio label="3">其他</Radio>
            </RadioGroup>
          </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="6">
          <FormItem label="管理员姓名"
                    label-position="top"
                    prop="admin_name">
            <Input v-model="dataInfo.admin_name"></Input>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="管理员手机"
                    label-position="top"
                    prop="mobile">
            <Input v-model="dataInfo.mobile"></Input>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="管理员邮箱"
                    label-position="top"
                    prop="email">
            <Input v-model="dataInfo.email"></Input>
          </FormItem>
          </Col>
          <Col span="6">
          <FormItem label="管理员身份证号"
                    label-position="top"
                    prop="admin_cert_no">
            <Input v-model="dataInfo.admin_cert_no"></Input>
          </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="8">
          <FormItem label="经营地址"
                    label-position="top"
                    prop="addr">
            <Input v-model="dataInfo.addr"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="注册地址 "
                    label-position="top"
                    prop="register_adrr">
            <Input v-model="dataInfo.register_adrr"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="经营范围"
                    label-position="top"
                    prop="business_scope">
            <Input type="textarea"
                   v-model="dataInfo.business_scope"
                   :autosize="{minRows:3,maxRows:3}"></Input>
          </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="8">
          <FormItem label="企业代码类型"
                    label-position="top">
            <RadioGroup v-model="dataInfo.enterprise_code_type">
              <Radio label="01">三证合一资质</Radio>
              <Radio label="02">三证未合一</Radio>
            </RadioGroup>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="企业代码"
                    label-position="top"
                    prop="enterprise_code">
            <Input v-model="dataInfo.enterprise_code"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="企业代码有效期"
                    label-position="top"
                    prop="enterprise_code_date">
            <!-- <DatePicker
                v-model="dataInfo.enterprise_code_date"
                format="yyyy-MM-dd"
                placeholder="企业代码有效期"
                style="width: 200px"
                @on-change="changeEcd"
              ></DatePicker>-->
            <Input v-model="dataInfo.enterprise_code_date"
                   placeholder="例：2099-12-31"></Input>
          </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="8">
          <FormItem label="税务登记号"
                    label-position="top">
            <Input v-model="dataInfo.register_no"></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="开户许可证"
                    label-position="top">
            <Input v-model="dataInfo.licence_number"></Input>
          </FormItem>
          </Col>
        </Row>

        <FormItem label="备注"
                  label-position="top"
                  prop="remark">
          <Input type="textarea"
                 v-model="dataInfo.remark"
                 :rows="3"
                 placeholder="备注" />
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="apply('dataInfoValidate')">提交</Button>
      </div>
    </Drawer>
    <!-- 添加 end -->
    <!-- 上传 start -->
    <Drawer :title="uploadTitle"
            v-model="showUpload"
            width="650"
            :mask-closable="false"
            :styles="uploadStyles">
      <Form :model="uploadForm"
            label-position="top"
            ref="uploadFormValidate"
            :rules="uploadFormValidate">
        <Row :gutter="20">
          <Col span="12">
          <FormItem label="园区UUID">
            <!-- <Input v-model="uploadForm.park_uuid" readonly disabled></Input> -->
            <span>{{ uploadForm.park_uuid }}</span>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="申请账户ID">
            <span>{{ uploadForm.apply_reaple_data_id }}</span>
            <!-- <Input disabled v-model="uploadForm.apply_reaple_data_id"></Input> -->
          </FormItem>
          </Col>
        </Row>
        <Row :gutter="20">
          <Col span="12">
          <FormItem label="营业执照"
                    prop="business_license">
            <upload-thumb v-model="uploadForm.business_license"
                          ref="business_license"
                          :multipleStatus="false"
                          :maxNum="1"
                          :defaultList="business_license_list"
                          :defaultTip="''"></upload-thumb>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="身份证正面照片"
                    prop="idcard_z">
            <upload-thumb v-model="uploadForm.idcard_z"
                          ref="idcard_z"
                          :multipleStatus="false"
                          :maxNum="1"
                          :defaultList="idcard_z_list"
                          :defaultTip="''"></upload-thumb>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="身份证反面照片"
                    prop="idcard_f">
            <upload-thumb v-model="uploadForm.idcard_f"
                          ref="idcard_f"
                          :multipleStatus="false"
                          :maxNum="1"
                          :defaultList="idcard_f_list"
                          :defaultTip="''"></upload-thumb>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="行业凭证1">
            <upload-thumb v-model="uploadForm.hypz_1"
                          ref="hypz_1"
                          :multipleStatus="false"
                          :maxNum="1"
                          :defaultList="hypz_1_list"
                          :defaultTip="''"></upload-thumb>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="行业凭证2">
            <upload-thumb v-model="uploadForm.hypz_2"
                          ref="hypz_2"
                          :multipleStatus="false"
                          :maxNum="1"
                          :defaultList="hypz_2_list"
                          :defaultTip="''"></upload-thumb>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="开户许可证">
            <upload-thumb v-model="uploadForm.khxkz"
                          ref="khxkz"
                          :multipleStatus="false"
                          :maxNum="1"
                          :defaultList="khxkz_list"
                          :defaultTip="''"></upload-thumb>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="往来协议">
            <file-import v-model="uploadForm.wlxy"
                         :format="['doc','docx','xls','xlsx','pdf','pem','jpg','jpeg','png','gif','zip']"
                         :defaultList="wlxy_list"
                         :alterString="'时代记忆与商户签约协议(仅支持PDF格式)'"
                         ref="wlxy"></file-import>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="融宝账户使用协议">
            <file-import v-model="uploadForm.rbzhsyxy"
                         :format="['doc','docx','xls','xlsx','pdf','pem','jpg','jpeg','png','gif','zip']"
                         :defaultList="rbzhsyxy_list"
                         :alterString="'融宝账户使用协议(仅支持PDF格式)'"
                         ref="rbzhsyxy"></file-import>
            <a style="margin-top:4px;"
               href="https://admin.shidaijiyi.com/template/%E9%99%84%E4%BB%B62%20%E8%9E%8D%E5%AE%9D%E4%BC%9A%E5%91%98%E8%B4%A6%E6%88%B7%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE-%E7%BA%B8%E7%AD%BE.doc"
               class="f-r ml10">下载协议模版</a>
          </FormItem>
          </Col>
          <Col span="12">
          </Col>
        </Row>
        <div class="demo-drawer-footer">
          <Button style="margin-right: 8px"
                  @click="showUpload = false">取消</Button>
          <Button type="primary"
                  @click="doUploadForm('uploadFormValidate')">提交</Button>
        </div>
      </Form>
    </Drawer>
    <!-- 上传 end -->
    <!-- 绑卡 -->
    <Drawer :title="bindCardTitle"
            v-model="showBindCard"
            width="600"
            :mask-closable="false"
            :styles="bindCardStyles">
      <Form :model="bindCardForm"
            label-position="top"
            ref="bindCardFormValidate"
            :rules="bindCardFormValidate"
            action="javascript:void(0)">
        <FormItem label="申请账户ID"
                  label-position="top">
          <span>{{ bindCardForm.apply_reaple_data_id }}</span>
          <!-- <Input v-model="bindCardForm.apply_reaple_data_id" placeholder="申请账户ID">></Input> -->
        </FormItem>
        <FormItem label="企业名称"
                  label-position="top"
                  prop="name">
          <Input v-model="bindCardForm.name"
                 placeholder="企业名称">></Input>
        </FormItem>
        <FormItem label="开户行"
                  label-position="top"
                  prop="bank_name">
          <Input v-model="bindCardForm.bank_name"
                 placeholder="开户行">></Input>
        </FormItem>
        <FormItem label="银行卡号"
                  label-position="top"
                  prop="card_no">
          <Input v-model="bindCardForm.card_no"
                 placeholder="银行卡号">></Input>
        </FormItem>
        <FormItem label="支行名称"
                  label-position="top"
                  prop="sub_branch_bank">
          <Input v-model="bindCardForm.sub_branch_bank"
                 placeholder="支行名称">></Input>
        </FormItem>
        <div class="demo-drawer-footer">
          <Button style="margin-right: 8px"
                  @click="showBindCard = false">取消</Button>
          <Button type="primary"
                  @click="doBindCardForm('bindCardFormValidate')">提交</Button>
        </div>
      </Form>
    </Drawer>
    <!-- 绑卡 end-->
    <Drawer title="公卡列表"
            v-model="showCardStatus"
            width="500"
            :mask-closable="false"
            :styles="bindCardStyles">
      <Table border
             :columns="columns1"
             :data="cardlist"
             :loading="dataloading"></Table>
      <!-- <Button @click="showModel()" type="success" class="f-r">请选择匠人</Button> -->
    </Drawer>
    <!-- 设置支付密码 -->
    <div v-html="paypwdForm"
         id="paypwdForm"
         style="position:absolute; top:-9999em; left:-9999em;"></div>
    <!--解绑卡-->
    <div v-html="unbindcardForm"
         id="unbindcardForm"
         style="position:absolute; top:-9999em; left:-9999em;"></div>

    <!-- <Modal title="解绑卡" v-model="unbindcardFormStatus" closable footer-hide :mask-closable="false">
      <div v-html="unbindcardForm"></div>
    </Modal>-->
  </div>
</template>

<script>
import UploadThumb from "../common/reapalthumb";
import FileImport from "../common/fileimport";

export default {
  name: "reapal-apply",
  data () {
    const validate_business_license = (rule, value, callback) => {
      if (this.$refs["business_license"].uploadList.length == 0) {
        callback(new Error("请上传营业执照"));
      } else {
        callback();
      }
    };
    const validate_tyxydm_list = (rule, value, callback) => {
      if (this.$refs["tyxydm"].uploadList.length == 0) {
        callback(new Error("请上传传统一信用代码"));
      } else {
        callback();
      }
    };
    const validate_idcard_z_list = (rule, value, callback) => {
      if (this.$refs["idcard_z"].uploadList.length == 0) {
        callback(new Error("请上传身份证正面照片"));
      } else {
        callback();
      }
    };
    const validate_idcard_f_list = (rule, value, callback) => {
      if (this.$refs["idcard_f"].uploadList.length == 0) {
        callback(new Error("请上传身份证反面照片"));
      } else {
        callback();
      }
    };
    const validate_hypz_1_list = (rule, value, callback) => {
      if (this.$refs["hypz_1"].uploadList.length == 0) {
        callback(new Error("请上传行业凭证1"));
      } else {
        callback();
      }
    };
    const validate_hypz_2_list = (rule, value, callback) => {
      if (this.$refs["hypz_2"].uploadList.length == 0) {
        callback(new Error("请上传行业凭证2"));
      } else {
        callback();
      }
    };
    const validate_other_1_list = (rule, value, callback) => {
      if (this.$refs["other_1"].uploadList.length == 0) {
        callback(new Error("请上传其他凭证1"));
      } else {
        callback();
      }
    };
    const validate_other_2_list = (rule, value, callback) => {
      if (this.$refs["other_2"].uploadList.length == 0) {
        callback(new Error("请上传其他凭证2"));
      } else {
        callback();
      }
    };
    const validate_other_3_list = (rule, value, callback) => {
      if (this.$refs["other_3"].uploadList.length == 0) {
        callback(new Error("请上传其他凭证3"));
      } else {
        callback();
      }
    };
    const validate_wlxy_list = (rule, value, callback) => {
      if (this.$refs["wlxy"].uploadList.length == 0) {
        callback(new Error("请上传往来协议"));
      } else {
        callback();
      }
    };
    const validate_fryhz_list = (rule, value, callback) => {
      if (this.$refs["fryhz"].uploadList.length == 0) {
        callback(new Error("请上传法人银行卡照片"));
      } else {
        callback();
      }
    };
    const validate_rbzhsyxy_list = (rule, value, callback) => {
      if (this.$refs["rbzhsyxy"].uploadList.length == 0) {
        callback(new Error("请上传融宝账户使用协议"));
      } else {
        callback();
      }
    };
    const validate_swdjz_list = (rule, value, callback) => {
      if (this.$refs["swdjz"].uploadList.length == 0) {
        callback(new Error("请上传税务登记证"));
      } else {
        callback();
      }
    };
    const validate_zjjgdmzp_list = (rule, value, callback) => {
      if (this.$refs["zjjgdmzp"].uploadList.length == 0) {
        callback(new Error("请上传组织机构代码照片"));
      } else {
        callback();
      }
    };
    const validate_khxkz_list = (rule, value, callback) => {
      if (this.$refs["khxkz"].uploadList.length == 0) {
        callback(new Error("请上传开户许可证"));
      } else {
        callback();
      }
    };
    const validate_frscyyzzzz_list = (rule, value, callback) => {
      if (this.$refs["frscyyzzzz"].uploadList.length == 0) {
        callback(new Error("请上传法人手持营业执照照片"));
      } else {
        callback();
      }
    };
    const validate_jszhkhzm_list = (rule, value, callback) => {
      if (this.$refs["jszhkhzm"].uploadList.length == 0) {
        callback(new Error("请上传结算账户开户正面"));
      } else {
        callback();
      }
    };
    const validate_sctyxydmzp_list = (rule, value, callback) => {
      if (this.$refs["sctyxydmzp"].uploadList.length == 0) {
        callback(new Error("请上传手持统一信用代码照片"));
      } else {
        callback();
      }
    };
    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      uploadStyles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      bindCardStyles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      parkList: {},
      loading: true,
      dataloading: true,
      title: "",
      uploadTitle: "上传资料",
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: "",
        status: ""
      },
      audit_state: [
        // 添加后状态为6，上传完等待审核，审核成功为1时提示绑卡
        { value: 0, label: "未提交到融宝" },
        { value: 1, label: "审核完成" },
        { value: 2, label: "待审核" },
        { value: 3, label: "审核中" },
        { value: 4, label: "审核拒绝" },
        { value: 5, label: "审核驳回" },
        { value: 6, label: "待上传附件" }
      ],
      list: [
        {
          title: "Id",
          key: "id",
          width: 90
        },
        {
          title: "申请人",
          key: "name",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.park == null ? "" : params.row.park.name)
            ]);
          }
        },
        {
          title: "注册类型",
          key: "registration_type",
          width: 90,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.registration_type == "01" ? "企业" : "个体商户"
              )
            ]);
          }
        },
        {
          title: "商户会员号",
          key: "cust_mem_id",
          width: 150
        },
        {
          title: "融宝会员号",
          key: "member_no",
          width: 150
        },
        {
          title: "企业全称",
          key: "enterprise_name",
          width: 100
        },
        {
          title: "营业执照编号",
          key: "business_code",
          width: 150
        },
        {
          title: "营业执照有效期",
          key: "business_valid_date",
          width: 150
        },
        {
          title: "注册资本",
          key: "registered_capital",
          width: 150
        },
        {
          title: "法人身份证号",
          key: "cert_no",
          width: 180
        },
        {
          title: "法人证件有效期",
          key: "legal_person_cert_date",
          width: 150
        },
        {
          title: "法人姓名",
          key: "legal_person_name",
          width: 150
        },
        {
          title: "法人常用邮箱",
          key: "legal_person_email",
          width: 150
        },
        {
          title: "法人手机号",
          key: "legal_person_mobile",
          width: 150
        },
        {
          title: "股东名",
          key: "shareholder",
          width: 150
        },
        {
          title: "所属省",
          key: "province_name",
          width: 150
        },
        {
          title: "所属市",
          key: "city_name",
          width: 150
        },
        {
          title: "管理员姓名",
          key: "admin_name",
          width: 150
        },
        {
          title: "管理员手机",
          key: "mobile",
          width: 150
        },
        {
          title: "管理员邮箱",
          key: "email",
          width: 150
        },
        {
          title: "管理员身份证号",
          key: "admin_cert_no",
          width: 150
        },
        {
          title: "经营地址",
          key: "addr",
          width: 150
        },
        {
          title: "注册地址",
          key: "register_adrr",
          width: 150
        },
        {
          title: "经营范围",
          key: "business_scope",
          width: 150,
          tooltip: true
        },
        {
          title: "企业代码类型",
          key: "enterprise_code_type",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.enterprise_code_type == "01"
                  ? "三证合一资质"
                  : "三证未合一"
              )
            ]);
          }
        },
        {
          title: "企业代码",
          key: "enterprise_code",
          width: 150
        },
        {
          title: "企业代码有效期",
          key: "enterprise_code_date",
          width: 150
        },
        {
          title: "税务登记号",
          key: "register_no",
          width: 150
        },

        {
          title: "开户许可证 ",
          key: "licence_number",
          width: 150
        },

        {
          title: "结算账户号",
          key: "settle_account_no",
          width: 150
        },

        {
          title: "法人银行卡",
          key: "legal_person_card_no",
          width: 150
        },
        {
          title: "开户名",
          key: "open_account_name",
          width: 150
        },
        {
          title: "开户银行",
          key: "open_account_bank",
          width: 150
        },
        {
          title: "审核状态",
          // key: 'created_at',
          minWidth: 150,
          render: (h, params) => {
            var s_name = new Array();
            s_name[0] = "未提交到融宝";
            s_name[1] = "审核完成";
            s_name[2] = "待审核";
            s_name[3] = "审核中";
            s_name[4] = "审核拒绝";
            s_name[5] = "审核驳回";
            s_name[6] = "待上传附件";
            // [-3 => '平台审核不通过'];
            return h("div", [h("span", {}, s_name[params.row.audit_state])]);
          }
        },
        {
          title: "备注",
          key: "remark",
          width: 150
        },
        {
          title: "操作",
          key: "action",
          width: 350,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                    // disabled:
                    //   params.row.audit_state != 0 && params.row.audit_state != 5
                    //     ? true
                    //     : false
                  },
                  on: {
                    click: () => {
                      this.detail(params.row);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                    // disabled: params.row.audit_state != 6 ? true : false
                  },
                  on: {
                    click: () => {
                      this.fujian(params.row);
                    }
                  }
                },
                "上传"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small",
                    disabled: params.row.audit_state != 1 ? true : false
                  },
                  on: {
                    click: () => {
                      this.bindCard(params.row);
                    }
                  }
                },
                "绑卡"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small",
                    disabled: params.row.audit_state != 1 ? true : false
                  },
                  on: {
                    click: () => {
                      this.showcardList(params.row);
                    }
                  }
                },
                "公卡列表"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small",
                    disabled: params.row.audit_state != 1 ? true : false
                  },
                  on: {
                    click: () => {
                      this.getPwd(params.row);
                    }
                  }
                },
                "设置支付密码"
              )
            ]);
          }
        }
      ],
      cardlist: [],
      showCardStatus: false,
      columns1: [
        {
          title: "卡号",
          key: "card_no",
          with: 100,
          render: (h, params) => {
            return h("div", [h("span", {}, params.row.card_no)]);
          }
        },
        {
          title: "融宝审核状态",
          key: "status",
          with: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.status == 1
                  ? "成功"
                  : params.row.status == 0
                    ? "未提交"
                    : "失败"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    disabled: params.row.status != 1 ? true : false
                  },
                  on: {
                    click: () => {
                      this.jiebang(params.row.id);
                    }
                  }
                },
                "解绑"
              )
            ]);
          }
        }
      ],
      columns: [
        {
          title: "原因",
          key: "result"
        },
        {
          title: "转账时间",
          key: "updated_at"
        }
      ],
      reviewOrder: {},
      tablelist: [],
      showModalStatus: false,
      dataInfo: {
        park_uuid: "",
        registration_type: "01",
        enterprise_name: "",
        business_code: "",
        business_valid_date: "",
        registered_capital: "",
        cert_no: "",
        legal_person_cert_date: "",
        legal_person_name: "",
        legal_person_email: "",
        legal_person_mobile: "",
        shareholder: "",
        province_name: "",
        city_name: "",
        channel: "3",
        admin_name: "",
        mobile: "",
        email: "",
        admin_cert_no: "",
        addr: "",
        register_adrr: "",
        business_scope: "",
        enterprise_code_type: "01",
        enterprise_code: "",
        enterprise_code_date: "",
        register_no: "",
        licence_number: "",
        settle_account_no: "",
        legal_person_card_no: "",
        open_account_name: "",
        open_account_bank: "",
        remark: ""
      },
      dataInfoValidate: {
        park_uuid: [
          {
            required: true,
            message: "部门必须选择",
            trigger: "change",
            type: "number"
          },
          {
            validator: function (rule, value, callback) {
              if (!value) {
                return callback(new Error("部门必须选择"));
              } else if (value < 1) {
                return callback(new Error("部门必须选择"));
              } else {
                callback();
              }
            },
            trigger: "change",
            type: "number"
          }
        ],
        enterprise_name: [
          { required: true, message: "企业名称", trigger: "blur" }
        ],
        cert_no: [{ required: true, message: "法人身份证号", trigger: "blur" }],
        legal_person_cert_date: [
          { required: true, message: "法人证件有效期", trigger: "blur" }
        ],
        province_name: [{ required: true, message: "所属省", trigger: "blur" }],
        city_name: [{ required: true, message: "所属市", trigger: "blur" }],
        admin_name: [
          { required: true, message: "管理员名字", trigger: "blur" }
        ],
        mobile: [{ required: true, message: "管理员手机", trigger: "blur" }],
        email: [{ required: true, message: "管理员邮箱", trigger: "blur" }],
        admin_cert_no: [
          { required: true, message: "管理员身份证号", trigger: "blur" }
        ],
        addr: [{ required: true, message: "经营地址", trigger: "blur" }],
        register_adrr: [
          { required: true, message: "注册地址", trigger: "blur" }
        ],
        business_scope: [
          { required: true, message: "经营范围", trigger: "blur" }
        ],
        settle_account_no: [
          { required: true, message: "结算账户卡号", trigger: "blur" }
        ],
        open_account_name: [
          { required: true, message: "开户账户名称", trigger: "blur" }
        ],
        open_account_bank: [
          { required: true, message: "开户银行", trigger: "blur" }
        ],
        enterprise_code: [
          { required: true, message: "企业代码", trigger: "blur" }
        ],
        enterprise_code_date: [
          { required: true, message: "企业代码有效期", trigger: "blur" }
        ]
      },
      showBindCard: false,
      bindCardTitle: "绑卡",
      bindCardForm: {
        apply_reaple_data_id: null,
        name: null,
        bank_name: null,
        card_no: null,
        sub_branch_bank: null
      },
      bindCardFormValidate: {
        apply_reaple_data_id: [
          { required: true, message: "申请账户ID必须填写", trigger: "blur" }
        ],
        name: [
          { required: true, message: "企业名称必须填写", trigger: "blur" }
        ],
        bank_name: [
          { required: true, message: "开户行必须填写", trigger: "blur" }
        ],
        card_no: [
          { required: true, message: "银行卡号必须填写", trigger: "blur" }
        ],
        sub_branch_bank: [
          { required: true, message: "支行名称必须填写", trigger: "blur" }
        ]
      },
      showUpload: false, // 是否显示上传弹窗
      uploadForm: {
        park_uuid: "", // 园区UUID,
        apply_reaple_data_id: "", // 申请账户ID,
        business_license: "", // 营业执照
        tyxydm: "", // 统一信用代码
        idcard_z: "", // 身份证正面照片
        idcard_f: "", // 身份证反面照片
        hypz_1: "", // 行业凭证1
        hypz_2: "", // 行业凭证2
        other_1: "", // 其他凭证1
        other_2: "", // 其他凭证2
        other_3: "", // 其他凭证3
        wlxy: "", // 往来协议
        fryhz: "", // 法人银行卡照片
        rbzhsyxy: "", // 融宝账户使用协议
        swdjz: "", // 税务登记证
        zjjgdmzp: "", // 组织机构代码照片
        khxkz: "", // 开户许可证
        frscyyzzzz: "", // 法人手持营业执照照片
        jszhkhzm: "", // 结算账户开户正面
        sctyxydmzp: "" // 手持统一信用代码照片
      },
      business_license_list: [], // 营业执照
      tyxydm_list: [], // 统一信用代码
      idcard_z_list: [], // 身份证正面照片
      idcard_f_list: [], // 身份证反面照片
      hypz_1_list: [], // 行业凭证1
      hypz_2_list: [], // 行业凭证2
      other_1_list: [], // 其他凭证1
      other_2_list: [], // 其他凭证2
      other_3_list: [], // 其他凭证3
      wlxy_list: [], // 往来协议
      fryhz_list: [], // 法人银行卡照片
      rbzhsyxy_list: [], // 融宝账户使用协议
      swdjz_list: [], // 税务登记证
      zjjgdmzp_list: [], // 组织机构代码照片
      khxkz_list: [], // 开户许可证
      frscyyzzzz_list: [], // 法人手持营业执照照片
      jszhkhzm_list: [], // 结算账户开户正面
      sctyxydmzp_list: [], // 手持统一信用代码照片
      uploadFormValidate: {
        park_uuid: [
          { required: true, message: "园区UUID不能为空", trigger: "blur" }
        ], // 园区UUID
        apply_reaple_data_id: [
          { required: true, message: "申请账户ID不能为空", trigger: "blur" }
        ], // 申请账户ID
        business_license: [
          {
            required: true,
            validator: validate_business_license,
            trigger: "change"
          }
        ], // 营业执照
        // tyxydm: [
        //   { required: true, validator: validate_tyxydm_list, trigger: "change" }
        // ], // 统一信用代码
        idcard_z: [
          {
            required: true,
            validator: validate_idcard_z_list,
            trigger: "change"
          }
        ], // 身份证正面照片
        idcard_f: [
          {
            required: true,
            validator: validate_idcard_f_list,
            trigger: "change"
          }
        ], // 身份证反面照片
        // hypz_1: [
        //   { required: true, validator: validate_hypz_1_list, trigger: "change" }
        // ], // 行业凭证1
        // hypz_2: [
        //   { required: true, validator: validate_hypz_2_list, trigger: "change" }
        // ], // 行业凭证2
        // other_1: [
        //   {
        //     required: true,
        //     validator: validate_other_1_list,
        //     trigger: "change"
        //   }
        // ], // 其他凭证1
        // other_2: [
        //   {
        //     required: true,
        //     validator: validate_other_2_list,
        //     trigger: "change"
        //   }
        // ], // 其他凭证2
        // other_3: [
        //   {
        //     required: true,
        //     validator: validate_other_3_list,
        //     trigger: "change"
        //   }
        // ], // 其他凭证3
        wlxy: [
          { required: true, validator: validate_wlxy_list, trigger: "change" }
        ], // 往来协议
        // fryhz: [
        //   { required: true, validator: validate_fryhz_list, trigger: "change" }
        // ], // 法人银行卡照片
        rbzhsyxy: [
          {
            required: true,
            validator: validate_rbzhsyxy_list,
            trigger: "change"
          }
        ], // 融宝账户使用协议
        // swdjz: [
        //   { required: true, validator: validate_swdjz_list, trigger: "change" }
        // ], // 税务登记证
        // zjjgdmzp: [
        //   {
        //     required: true,
        //     validator: validate_zjjgdmzp_list,
        //     trigger: "change"
        //   }
        // ], // 组织机构代码照片
        khxkz: [
          { required: true, validator: validate_khxkz_list, trigger: "change" }
        ], // 开户许可证
        // frscyyzzzz: [
        //   {
        //     required: true,
        //     validator: validate_frscyyzzzz_list,
        //     trigger: "change"
        //   }
        // ], // 法人手持营业执照照片
        jszhkhzm: [
          {
            required: true,
            validator: validate_jszhkhzm_list,
            trigger: "change"
          }
        ] // 结算账户开户证明
        // sctyxydmzp: [
        //   {
        //     required: true,
        //     validator: validate_sctyxydmzp_list,
        //     trigger: "change"
        //   }
        // ] // 手持统一信用代码照片
      },
      paypwdForm: null, // 设置支付密码表单
      unbindcardForm: null // 解绑表单
      // unbindcardFormStatus: false
    };
  },
  created: function () {
    this.$api.park.list({ page: 1, size: 999 }).then(res => {
      this.dataloading = false;
      this.parkList = res.result.list;
    });
    this.getTableList();
  },
  components: {
    UploadThumb,
    FileImport
  },
  methods: {
    getTableList: function () {
      this.$api.reaplyapply
        .list({ page: this.pages.page, size: this.pages.size })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.role_ids = res.result.role_ids;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    showcardList (index) {
      this.showCardStatus = true;
      this.$api.reaplyapply
        .cardlist({ apply_reaple_data_id: index.id })
        .then(res => {
          if (res.code == 200) {
            this.cardlist = res.result;
          }
        });
    },
    jiebang: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.reaplyapply.unbindcard({ id: index }).then(res => {
            if (res.code == 200) {
              // this.$Message.success(res.msg);
              this.unbindcardForm = res.result;
              setTimeout(function () {
                document.querySelector("#unbindcardForm form").submit();
              }, 100);
            }
          });
        }
      });
    },

    //展开修改
    detail: function (index) {
      this.id = index.id;
      this.showModalStatus = !this.showModalStatus;
      // 取信息
      this.$api.reaplyapply.detail({ id: this.id }).then(res => {
        if (res.code == 200) {
          this.dataInfo = res.result;
          this.dataInfo.channel = this.dataInfo.channel.toString();
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    bindCard (item) {
      var that = this;
      that.bindCardForm = {
        apply_reaple_data_id: item.id,
        name: "",
        bank_name: "",
        card_no: "",
        sub_branch_bank: ""
      };
      if (item.apply_reaple_data_id) {
        //cardDetail
        that.$api.reaplyapply
          .cardDetail(item.apply_reaple_data_id)
          .then(res => {
            if (res.code == 200) {
              this.bindCardForm = res.result;
            }
            that.showBindCard = true;
          });
      } else {
        that.showBindCard = true;
      }
    },
    doBindCardForm (name) {
      var that = this;
      that.$refs[name].validate(valid => {
        if (valid) {
          that.$api.reaplyapply.bindCard(that.bindCardForm).then(res => {
            that.loading = false;
            if (res.code == 200) {
              that.showBindCard = false;
              that.getTableList();
            }
          });
        }
      });
    },
    // 附件详情
    fujian (item) {
      var that = this;
      that.uploadForm = {
        park_uuid: item.park_uuid, // 园区UUID,
        apply_reaple_data_id: item.id, // 申请账户ID,
        business_license: "", // 营业执照
        tyxydm: "", // 统一信用代码
        idcard_z: "", // 身份证正面照片
        idcard_f: "", // 身份证反面照片
        hypz_1: "", // 行业凭证1
        hypz_2: "", // 行业凭证2
        other_1: "", // 其他凭证1
        other_2: "", // 其他凭证2
        other_3: "", // 其他凭证3
        wlxy: "", // 往来协议
        fryhz: "", // 法人银行卡照片
        rbzhsyxy: "", // 融宝账户使用协议
        swdjz: "", // 税务登记证
        zjjgdmzp: "", // 组织机构代码照片
        khxkz: "", // 开户许可证
        frscyyzzzz: "", // 法人手持营业执照照片
        jszhkhzm: "", // 结算账户开户正面
        sctyxydmzp: "" // 手持统一信用代码照片
      };
      that.business_license_list = []; // 营业执照
      that.tyxydm_list = []; // 统一信用代码
      that.idcard_z_list = []; // 身份证正面照片
      that.idcard_f_list = []; // 身份证反面照片
      that.hypz_1_list = []; // 行业凭证1
      that.hypz_2_list = []; // 行业凭证2
      that.other_1_list = []; // 其他凭证1
      that.other_2_list = []; // 其他凭证2
      that.other_3_list = []; // 其他凭证3
      that.wlxy_list = []; // 往来协议
      that.fryhz_list = []; // 法人银行卡照片
      that.rbzhsyxy_list = []; // 融宝账户使用协议
      that.swdjz_list = []; // 税务登记证
      that.zjjgdmzp_list = []; // 组织机构代码照片
      that.khxkz_list = []; // 开户许可证
      that.frscyyzzzz_list = []; // 法人手持营业执照照片
      that.jszhkhzm_list = []; // 结算账户开户正面
      that.sctyxydmzp_list = []; // 手持统一信用代码照片

      that.showUpload = !that.showUpload;
      this.$api.reaplyapply
        .cardDetail({ apply_reaple_data_id: item.id })
        .then(res => {
          if (res.code == 200) {
            if (res.result) {
              that.uploadForm = res.result;
            }

            // this.showModalStatus = !this.showModalStatus;
            if (
              res.result &&
              res.result.business_license &&
              res.result.business_license != undefined &&
              res.result.business_license != ""
            ) {
              that.business_license_list = [
                {
                  name: res.result.business_license,
                  url: res.result.business_license,
                  status: "finished"
                }
              ]; // 营业执照
            }
            if (
              res.result &&
              res.result.idcard_z &&
              res.result.idcard_z != undefined &&
              res.result.idcard_z != ""
            ) {
              that.idcard_z_list = [
                {
                  name: res.result.idcard_z,
                  url: res.result.idcard_z,
                  status: "finished"
                }
              ]; // 身份证正面照片
            }
            if (
              res.result &&
              res.result.idcard_f &&
              res.result.idcard_f != undefined &&
              res.result.idcard_f != ""
            ) {
              that.idcard_f_list = [
                {
                  name: res.result.idcard_f,
                  url: res.result.idcard_f,
                  status: "finished"
                }
              ]; // 身份证反面照片
            }
            if (
              res.result &&
              res.result.khxkz &&
              res.result.khxkz != undefined &&
              res.result.khxkz != ""
            ) {
              that.khxkz_list = [
                {
                  name: res.result.khxkz,
                  url: res.result.khxkz,
                  status: "finished"
                }
              ]; // 开户许可证
            }
            if (
              res.result &&
              res.result.hypz_1 &&
              res.result.hypz_1 != undefined &&
              res.result.hypz_1 != ""
            ) {
              that.hypz_1_list = [
                {
                  name: res.result.hypz_1,
                  url: res.result.hypz_1,
                  status: "finished"
                }
              ]; // 行业凭证1
            }
            if (
              res.result &&
              res.result.hypz_2 &&
              res.result.hypz_2 != undefined &&
              res.result.hypz_2 != ""
            ) {
              that.hypz_2_list = [
                {
                  name: res.result.hypz_2,
                  url: res.result.hypz_2,
                  status: "finished"
                }
              ]; // 行业凭证2
            }
            if (
              res.result &&
              res.result.wlxy &&
              res.result.wlxy != undefined &&
              res.result.wlxy != ""
            ) {
              that.wlxy_list = [
                {
                  name: res.result.wlxy,
                  url: res.result.wlxy,
                  percentage: 100,
                  uid: 1,
                  status: "finished"
                }
              ]; // 往来协议
            }
            if (
              res.result &&
              res.result.rbzhsyxy &&
              res.result.rbzhsyxy != undefined &&
              res.result.rbzhsyxy != ""
            ) {
              that.rbzhsyxy_list = [
                {
                  name: res.result.rbzhsyxy,
                  url: res.result.rbzhsyxy,
                  percentage: 100,
                  uid: 2,
                  status: "finished"
                }
              ]; // 融宝账户使用协议
            }
          }
        });
    },
    // 添加
    doUploadForm: function (name) {
      var that = this;
      // console.log(this.$refs["wlxy"].resList)
      // return
      that.$refs[name].validate(valid => {
        if (valid) {
          this.park_uuid = that.uploadForm.park_uuid; // 园区UUID
          this.apply_reaple_data_id = that.uploadForm.apply_reaple_data_id; // 申请账户ID
          if (this.$refs["business_license"].uploadList.length > 0) {
            this.business_license = this.$refs[
              "business_license"
            ].uploadList[0].url;
          } else {
            this.business_license = null;
          } // 营业执照
          // if (this.$refs["tyxydm"].uploadList.length > 0) {
          //   this.tyxydm = this.$refs["tyxydm"].uploadList[0].url;
          // } else {
          //   this.tyxydm = null;
          // } // 统一信用代码
          if (this.$refs["idcard_z"].uploadList.length > 0) {
            this.idcard_z = this.$refs["idcard_z"].uploadList[0].url;
          } else {
            this.idcard_z = null;
          } // 身份证正
          if (this.$refs["idcard_f"].uploadList.length > 0) {
            this.idcard_f = this.$refs["idcard_f"].uploadList[0].url;
          } else {
            this.idcard_f = null;
          } // 身份证反
          if (this.$refs["hypz_1"].uploadList.length > 0) {
            this.hypz_1 = this.$refs["hypz_1"].uploadList[0].url;
          } else {
            this.hypz_1 = null;
          } // 行业凭证1
          if (this.$refs["hypz_2"].uploadList.length > 0) {
            this.hypz_2 = this.$refs["hypz_2"].uploadList[0].url;
          } else {
            this.hypz_2 = null;
          } // 行业凭证2
          // if (this.$refs["other_1"].uploadList.length > 0) {
          //   this.other_1 = this.$refs["other_1"].uploadList[0].url;
          // } else {
          //   this.other_1 = null;
          // } // 其他凭证1
          // if (this.$refs["other_2"].uploadList.length > 0) {
          //   this.other_2 = this.$refs["other_2"].uploadList[0].url;
          // } else {
          //   this.other_2 = null;
          // } // 其他凭证2
          // if (this.$refs["other_3"].uploadList.length > 0) {
          //   this.other_3 = this.$refs["other_3"].uploadList[0].url;
          // } else {
          //   this.other_3 = null;
          // } // 其他凭证3
          if (this.$refs["wlxy"].resList.length > 0) {
            this.wlxy = this.$refs["wlxy"].resList[0].url;
          } else {
            this.wlxy = null;
          } // 往来协议
          // if (this.$refs["fryhz"].uploadList.length > 0) {
          //   this.fryhz = this.$refs["fryhz"].uploadList[0].url;
          // } else {
          //   this.fryhz = null;
          // } // 法人银行卡照片
          if (this.$refs["rbzhsyxy"].resList.length > 0) {
            this.rbzhsyxy = this.$refs["rbzhsyxy"].resList[0].url;
          } else {
            this.rbzhsyxy = null;
          } // 融宝账户使用协议
          // if (this.$refs["swdjz"].uploadList.length > 0) {
          //   this.swdjz = this.$refs["swdjz"].uploadList[0].url;
          // } else {
          //   this.swdjz = null;
          // } // 税务登记证
          // if (this.$refs["zjjgdmzp"].uploadList.length > 0) {
          //   this.zjjgdmzp = this.$refs["zjjgdmzp"].uploadList[0].url;
          // } else {
          //   this.zjjgdmzp = null;
          // } // 组织机构代码照片
          if (this.$refs["khxkz"].uploadList.length > 0) {
            this.khxkz = this.$refs["khxkz"].uploadList[0].url;
          } else {
            this.khxkz = null;
          } // 开户许可证
          // if (this.$refs["frscyyzzzz"].uploadList.length > 0) {
          //   this.frscyyzzzz = this.$refs["frscyyzzzz"].uploadList[0].url;
          // } else {
          //   this.frscyyzzzz = null;
          // } // 法人手持营业执照照片
          // if (this.$refs["jszhkhzm"].uploadList.length > 0) {
          //   this.jszhkhzm = this.$refs["jszhkhzm"].uploadList[0].url;
          // } else {
          //   this.jszhkhzm = null;
          // } // 结算账户开户正面
          // if (this.$refs["sctyxydmzp"].uploadList.length > 0) {
          //   this.sctyxydmzp = this.$refs["sctyxydmzp"].uploadList[0].url;
          // } else {
          //   this.sctyxydmzp = null;
          // } // 手持统一信用代码照片
          var params = {
            park_uuid: this.park_uuid, // 园区UUID,
            apply_reaple_data_id: this.apply_reaple_data_id, // 申请账户ID,
            business_license: this.business_license, // 营业执照
            tyxydm: this.tyxydm, // 统一信用代码
            idcard_z: this.idcard_z, // 身份证正面照片
            idcard_f: this.idcard_f, // 身份证反面照片
            hypz_1: this.hypz_1, // 行业凭证1
            hypz_2: this.hypz_2, // 行业凭证2
            other_1: this.other_1, // 其他凭证1
            other_2: this.other_2, // 其他凭证2
            other_3: this.other_3, // 其他凭证3
            wlxy: this.wlxy, // 往来协议
            fryhz: this.fryhz, // 法人银行卡照片
            rbzhsyxy: this.rbzhsyxy, // 融宝账户使用协议
            swdjz: this.swdjz, // 税务登记证
            zjjgdmzp: this.zjjgdmzp, // 组织机构代码照片
            khxkz: this.khxkz, // 开户许可证
            frscyyzzzz: this.frscyyzzzz, // 法人手持营业执照照片
            jszhkhzm: this.jszhkhzm, // 结算账户开户正面
            sctyxydmzp: this.sctyxydmzp // 手持统一信用代码照片
          };
          // that.$Message.success("验证通过");
          that.$api.reaplyapply.upload(params).then(res => {
            if (res.code == 200) {
              this.showUpload = false;
              that.getTableList();
            }
          });
        } else {
          that.$Message.success("验证不通过");
        }
      });
    },
    // 展开添加
    showModel () {
      this.title = "添加";
      this.dataInfo = {
        park_uuid: "",
        registration_type: "01",
        enterprise_name: "",
        business_code: "",
        business_valid_date: "",
        registered_capital: "",
        cert_no: "",
        legal_person_cert_date: "",
        legal_person_name: "",
        legal_person_email: "",
        legal_person_mobile: "",
        shareholder: "",
        province_name: "",
        city_name: "",
        channel: "3",
        admin_name: "",
        mobile: "",
        email: "",
        admin_cert_no: "",
        addr: "",
        register_adrr: "",
        business_scope: "",
        enterprise_code_type: "01",
        enterprise_code: "",
        enterprise_code_date: "",
        register_no: "",
        licence_number: "",
        settle_account_no: "",
        legal_person_card_no: "",
        open_account_name: "",
        open_account_bank: "",
        remark: ""
      };
      this.$refs["dataInfoValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    // changeBvd(val) {
    //   this.dataInfo.business_valid_date = val;
    // },
    // changeLpcd(val) {
    //   this.dataInfo.legal_person_cert_date = val;
    // },
    // changeEcd(val) {
    //   this.dataInfo.enterprise_code_date = val;
    // },
    // 添加
    apply: function (name) {
      if (this.id == null || this.id == 0 || this.id == undefined) {
        this.$api.reaplyapply.create(this.dataInfo).then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.showModalStatus = false;
          }
        });
      } else {
        this.dataInfo.id = this.id;
        this.$api.reaplyapply.edit(this.dataInfo).then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.showModalStatus = false;
          }
        });
      }
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        status: this.formItem.status
      };
      this.$api.reaplyapply.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.role_ids = res.result.role_ids;
          this.pages.total = res.result.total;
        }
      });
      return;
    },
    // 获取融宝
    getPwd (row) {
      // console.log(row);
      this.$api.reaplyapply.paypwd({ id: row.id }).then(res => {
        // console.log(res.result);
        // return;
        if (res.code == 200) {
          this.paypwdForm = res.result;

          setTimeout(function () {
            document.querySelector("#paypwdForm form").submit();
          }, 100);
        }
      });
    },
    toRongbao (uuid) {
      window.open("https://crm.reapal.com/index-main");
    }
  }
};
</script>

<style scoped>
</style>